import { useState } from "react";
import { Controller } from "react-hook-form";
import { Row, Col, Button, Form } from "react-bootstrap";
import { Input } from "../../../common/input/Input";
import { AsyncPaginate } from "react-select-async-paginate";

export const SampleDetailsSection = ({
  control,
  register,
  errors,
  sampleFields,
  loadProductOptions,
  sampleProductLabels,
  setSampleProductLabels,
}) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#fff",
      borderColor: "#9e9e9e",
      boxShadow: state.isFocused ? "0 0 0 1px #9e9e9e" : "none",
    }),

    menu: (base) => ({
      ...base,
      backgroundColor: "#fff",
      zIndex: 9999,
    }),

    menuList: (base) => ({
      ...base,
      backgroundColor: "#fff",
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#f5f5f5" : "#fff",
      color: "#000",
      cursor: "pointer",
    }),

    singleValue: (base) => ({
      ...base,
      color: "#000",
    }),

    input: (base) => ({
      ...base,
      color: "#000",
    }),
  };
  const [removingIndex, setRemovingIndex] = useState(null);
  const handleRemove = (index) => {
    setRemovingIndex(index);
    setTimeout(() => {
      sampleFields.remove(index);
      setRemovingIndex(null);
    }, 1000); // match animation duration
  };
  return (
    <div>
      {sampleFields.fields.length > 0 && (
        <h4>
          <span>Sample </span>
          Details
        </h4>
      )}
      {sampleFields.fields.map((item, index) => (
        <div
          key={item.id}
          className={`align-items-end animate__animated ${
            removingIndex === index
              ? "animate__zoomOutDown"
              : "animate__zoomInUp"
          }`}
        >
          <h5 className="mt-3 mb-1">Item #{index + 1}</h5> {/* Number label */}
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3" style={{ position: "relative" }}>
                <Form.Label>Product</Form.Label>
                <Controller
                  control={control}
                  name={`sampleDetailsRequestDtos.${index}.productId`}
                  render={({ field }) => (
                    <AsyncPaginate
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={customStyles}
                      value={
                        field.value
                          ? {
                              value: field.value,
                              label:
                                sampleProductLabels[field.value]?.label ||
                                "Loading...",
                            }
                          : null
                      }
                      loadOptions={loadProductOptions}
                      onChange={(option) => {
                        field.onChange(option?.value);
                        setSampleProductLabels((prev) => ({
                          ...prev,
                          [option?.value]: {
                            label: option?.label,
                            price: option?.price,
                          },
                        }));
                      }}
                      additional={{ page: 1 }}
                      isClearable
                      placeholder="Select Sample Product"
                    />
                  )}
                />
                {errors?.sampleDetailsRequestDtos?.[index]?.productId && (
                  <p
                    className="text-danger mb-0 animate__animated animate__headShake"
                    style={{
                      position: "absolute",
                      bottom: -20,
                      left: 0,
                      fontSize: "0.875rem",
                    }}
                  >
                    {errors.sampleDetailsRequestDtos[index].productId.message}
                  </p>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Input
                label="Quantity"
                field={`sampleDetailsRequestDtos.${index}.quantity`}
                register={register}
                errors={errors}
                type="number"
              />
            </Col>
            <Col md={2}>
              <Form.Group className="mb-3">
                <Form.Label>&nbsp;</Form.Label>
                <Button
                  variant="outline-danger"
                  onClick={() => handleRemove(index)}
                  disabled={removingIndex === index}
                  className="w-100"
                >
                  Remove
                </Button>
              </Form.Group>
            </Col>
          </Row>
        </div>
      ))}
      <Row>
        <Col md={{ span: 2, offset: 10 }}>
          <Button
            className="w-100"
            variant="outline-warning"
            onClick={() => sampleFields.append({ productId: "", quantity: 1 })}
          >
            Add Sample
          </Button>
        </Col>
      </Row>
    </div>
  );
};
